import React, { FC, PropsWithChildren } from 'react';
import { range } from 'ramda';
import { Box, Paper, PaperProps, BoxProps, Divider } from '@dxb-web-ui-framework/design-system';

export interface SkeletonWrapperListProps {
  Component: FC<any>;
  boxProps: BoxProps;
  paperProps: PaperProps;
  componentProps?: PropsWithChildren<any>;
  skeletonsToDisplay?: number;
  hasDivider?: boolean;
}

const SkeletonWrapperList: FC<SkeletonWrapperListProps> = ({
  boxProps,
  Component,
  paperProps,
  componentProps,
  skeletonsToDisplay = 3,
  hasDivider = false,
}) => {
  const returnedJSX = range(0, skeletonsToDisplay).map((_, index) => (
    <React.Fragment key={`Skeleton-mobile-item-${index}`}>
      <Box pb={hasDivider || index !== skeletonsToDisplay - 1 ? 2 : 0} pt={hasDivider ? 2 : 0} px={hasDivider ? 3 : 0}>
        <Component {...componentProps} />
      </Box>
      {hasDivider && <Divider />}
    </React.Fragment>
  ));

  return (
    <Paper {...paperProps}>
      <Box {...boxProps}>{returnedJSX}</Box>
    </Paper>
  );
};

export { SkeletonWrapperList };
